import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";
import { BORDER_RADIUS, BORDER_OPACITY } from "./constants";

const pillBadgeVariants = cva(
	"inline-flex items-center justify-center border bg-white font-medium text-foreground dark:bg-card",
	{
		variants: {
			variant: {
				default: "",
			},
			size: {
				default: "px-4 py-1.5",
				sm: "px-3 py-1",
				lg: "px-6 py-2",
			},
		},
		defaultVariants: {
			variant: "default",
			size: "default",
		},
	},
);

export interface PillBadgeProps
	extends React.HTMLAttributes<HTMLSpanElement>,
		VariantProps<typeof pillBadgeVariants> {}

const PillBadge = React.forwardRef<HTMLSpanElement, PillBadgeProps>(
	({ className, variant, size, ...props }, ref) => {
		return (
			<span
				ref={ref}
				className={cn(
					pillBadgeVariants({ variant, size }),
					BORDER_RADIUS.full,
					BORDER_OPACITY.standard,
					className,
				)}
				{...props}
			/>
		);
	},
);
PillBadge.displayName = "PillBadge";

export { PillBadge, pillBadgeVariants };

